/**
 * 未ログインのルート
 */
export default [
  {
    path: '/auth/login',
    name: 'auth.login',
    component: () => import(
      /* webpackChunkName: "auth_login" */
      '../views/auth/Login.vue'
    )
  },
  {
    path: '/auth/forgot-password',
    name: 'auth.forgot-password',
    component: () => import(
      /* webpackChunkName: "auth_forgot-password" */
      '../views/auth/ForgotPassword.vue'
    )
  }
]
